import type { InstallPlatform } from './installPlatforms';

export function getInstallBrowser(userAgent: string) {
  const ios = /iPhone|iPad|iPod/i.test(userAgent);
  const embedded = /MicroMessenger|QQ\//i.test(userAgent);
  const xiaomi = /MiuiBrowser|MiBrowser|XiaoMi/i.test(userAgent);
  const harmony = /HarmonyOS|OpenHarmony|HuaweiBrowser/i.test(userAgent);
  const platform: InstallPlatform = ios ? 'ios' : harmony ? 'harmony' : 'android';
  const name = embedded ? '应用内浏览器' : xiaomi ? '小米浏览器'
    : ios ? 'Safari 浏览器' : harmony ? '华为浏览器' : /Edg/i.test(userAgent) ? 'Edge 浏览器'
      : /Chrome/i.test(userAgent) ? 'Chrome 浏览器' : '当前浏览器';
  return { name, embedded, platform };
}
